import React from 'react';

import { Box, H4, Icon, ListRow, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { FINANCIAL_COACHING_401K_URL } from '../../../../AdviceInitiationFlow/constants';
import { trackClick } from '../../../../features/track';
import { addAccountUrl } from '../../../../Shared/addAccountUrl';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { ProductSelectionOptionsQuery } from '../graphql/productSelectionOptions.generated';

type ProductOnboardingOption = ProductSelectionOptionsQuery['productOnboardingOptions'][number];

const getProductUrl = (option: ProductOnboardingOption): string => {
  if (option.__typename === 'FinancialCoachingOnboardingOption') {
    return FINANCIAL_COACHING_401K_URL;
  }
  if (option.__typename === 'PremiumOnboardingOption') {
    return urlBuilder.appAdviceInitiationFlow.absolute();
  }

  return addAccountUrl({ product_category: option.legacyProductCategory });
};

export const ProductRow: React.FC<{ option: ProductOnboardingOption }> = ({ option }) => {
  return (
    <Box className="group">
      <SambaAutoLink
        to={getProductUrl(option)}
        title={option.name}
        css={{ textDecoration: 'none!important' }}
        onClick={() => trackClick({ name: option.legacyProductCategory, flow: 'AddGoal', module: 'ProductCategory' })}
      >
        <ListRow css={{ px: '0' }}>
          <ListRow.LeadingAsset css={{ width: '36px' }}>
            <ThemedImage themedAsset={option.image} alt={`${option.name} icon`} />
          </ListRow.LeadingAsset>
          <ListRow.LeadingContent>
            <H4
              variant="title100"
              color="text"
              css={{ textDecoration: { _groupHover: 'underline', _groupFocus: 'underline' } }}
            >
              {option.name}
            </H4>
            <Text variant="text50" color="text.weak">
              {option.shortDescription}
            </Text>
          </ListRow.LeadingContent>
          <ListRow.TrailingAsset>
            <Icon name="CaretRight" size="small" color="icon" />
          </ListRow.TrailingAsset>
        </ListRow>
      </SambaAutoLink>
    </Box>
  );
};
